import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguaeDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguaeDetector) // 사용자 언어 탐지
  .use(initReactI18next) // i18n 객체를 react-18next에 전달
  .init({
    // for all options read: https://www.i18next.com/overview/configuration-options
    debug: false,
    fallbackLng: "ko",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // 언어 감지 순서
      order: ["navigator", "htmlTag", "path", "subdomain"],
    },
    resources: {
      en: {
        translation: {
          header: {
            title: "Gwangju Biennale",
            mapView: "Map",
            listView: "List",
            searchHelpText: "Find a place",
          },
          listAll: {
            total: "All",
            exhibitions: "Exhibition",
            experiences: "Pavilion",
            shuttles: "Shuttle",
            etcs: "Etc",
            currentPlace: "Current Location : ",
            GuideWhereToGo: "What exhibition do you want next?",
          },
          detail: {
            openTime: "Exhibition hours",
            buttonNavigateWalkWay: "Walking directions",
            buttonNavigatePublic: "Public transport",
            buttonNavigateShuttle: "Taking the shuttle bus",
            buttonNavigateOnlyImage: "How to find directions",
          },
          path: {
            headerText1: "",
            headerText2: "Directions to",
            listitemNavigateWalkWay: "Walk to the ",
            listitemNavigatePublic: "Public transportation to ",
            listitemNavigateShuttle: "Take the shuttle to the ",
            shuttlebusStop: "shuttle stop",
          },
          pathList: {
            shuttleInfo: "Info",
            navigate: "Directions",
          },
          qrGuide: {
            titleText1: "How to get from",
            titleText2: "to the next exhibition hall",
            bottomInfoText1: "Scan the QR code in front of the exhibition hall",
            bottomInfoText2: "kakaomobility will show you the most",
            bottomInfoText2_1: "comfortable way to the next exhibition hall",
          },
          shuttleInfo: {
            titleTypeA: "Gwangju Biennale Exhibition Hall",
            titleTypeB: "Asia Culture Center",
            titleTypeC: "Yangnim History and Culture Village",
            titleTypeD: "U·Square Bus stop",
            kakaoFreeShuttle: "kakaomobility Free Shuttle",
            BottomInfoText1_1: "With just a Gwangju Biennale ticket, you can",
            BottomInfoText1_2: "take the Gwangju Biennale Free Shuttle Bus",
            BottomInfoText1_3: "provided by Kakao Mobility!",
            BottomInfoText2_1: "Operation Period: Sep 7, 2024 - Dec 1, 2024",
            BottomInfoText2_2: "Operation Days: Every Tuesday – Sunday",
          },
        },
      },
      ko: {
        translation: {
          header: {
            title: "광주비엔날레 길찾기",
            mapView: "지도보기",
            listView: "목록보기",
            searchHelpText: "시설, 장소를 검색해주세요",
          },
          listAll: {
            total: "전체",
            exhibitions: "본전시",
            experiences: "파빌리온",
            shuttles: "셔틀버스",
            etcs: "기타",
            currentPlace: "현위치 : ",
            GuideWhereToGo: "다음 전시는 어디로 가고싶으신가요?",
          },
          detail: {
            openTime: "전시시간",
            buttonNavigateWalkWay: "도보 길찾기",
            buttonNavigatePublic: "대중교통 길찾기",
            buttonNavigateShuttle: "셔틀버스 길찾기",
            buttonNavigateOnlyImage: "전시장 길안내",
          },
          path: {
            headerText1: "까지",
            headerText2: "길안내를 도와드릴게요.",
            listitemNavigateWalkWay: "까지 도보 이동",
            listitemNavigatePublic: "까지 대중교통 이동",
            listitemNavigateShuttle: " 셔틀정류장까지 셔틀 이용하기",
            shuttlebusStop: "셔틀버스 정류장",
          },
          pathList: {
            shuttleInfo: "셔틀 정보",
            navigate: "길찾기",
          },
          qrGuide: {
            titleText1: "에서",
            titleText2: "다음 전시장까지 가는 방법",
            bottomInfoText1: "전시장 앞 QR을 찍어보세요!",
            bottomInfoText2: "다음 전시장까지 가는 가장 편한 길을",
            bottomInfoText2_1: "카카오모빌리티가 안내해 드릴게요",
          },
          shuttleInfo: {
            titleTypeA: "광주비엔날레 전시관",
            titleTypeB: "국립아시아문화전당",
            titleTypeC: "양림역사문화마을",
            titleTypeD: "유·스퀘어 버스 터미널",
            kakaoFreeShuttle: "카카오모빌리티 무료 순환 셔틀",
            BottomInfoText1_1: "광주비엔날레 티켓만 있으면",
            BottomInfoText1_2: "카카오모빌리티가 제공하는 광주비엔날레",
            BottomInfoText1_3: "무료 셔틀 버스를 탈 수 있어요!",
            BottomInfoText2_1: "운행 기간 : 2024.9.7 - 12.1",
            BottomInfoText2_2: "운행 요일 : 매주 화요일 - 일요일",
          },
        },
      },
    },
  });

export default i18n;
